import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppVersion } from '../../../../models/core/app-version.model';
import { AppVersionService } from '../../../../services/app-version.service.ts.service';

@Component({
  selector: 'app-version-update-modal',
  templateUrl: './version-update-modal.component.html',
  styleUrls: ['./version-update-modal.component.scss'],
  standalone: false
})
export class VersionUpdateModalComponent implements OnInit {
  @Input() isOpen: boolean = false;
  @Input() latestVersionInfo: AppVersion | null = null;
  @Input() currentVersion: string = '';
  @Output() modalClosed = new EventEmitter<void>();

  isRequired: boolean = false;
  latestVersion: string = '';
  releaseNotes: string = '';
  downloadUrl: string = '';

  constructor(
    private modalController: ModalController,
    private appVersionService: AppVersionService
  ) { }

  ngOnInit() {
    if (this.latestVersionInfo) {
      this.isRequired = this.latestVersionInfo.is_required;
      this.latestVersion = this.latestVersionInfo.version;
      this.releaseNotes = this.latestVersionInfo.release_notes || '';
      this.downloadUrl = this.latestVersionInfo.download_url;
    }
  }

  async updateApp() {
    if (this.downloadUrl) {
      try {
        await this.appVersionService.openDownloadUrl(this.downloadUrl);
        this.dismiss();
      } catch (error) {
        console.error('Error abriendo URL de descarga:', error);
      }
    }
  }

  async dismiss() {
    if (this.isRequired) {
      return;
    }

    await this.modalController.dismiss();
    this.modalClosed.emit();
  }
}
